<template>
<div class="setting">
    <router-view :param="param"></router-view>
</div>
</template>

<script>
import {mapActions} from 'vuex'
import {initPage} from 'common/js/mixin'

export default {
    name: 'setting',
    mixins: [initPage],
    data() {
        return {
            param: {
                eventinnerid: '',
                paytype: '',
                payordero: '',
                username: '',
                parentnameone: '',
                parentnametwo: ''
            }
        }
    },
    mounted() {
        this.setParams(this._.cloneDeep(this.param))
    },
    methods: {
        ...mapActions([
            'setParams'
        ])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.setting {
}
</style>
